import React, { useState } from "react"
import { ISubContext } from "../context/types"

export class TableState {
  autoHeight: boolean = false;
}

type SDT = React.Dispatch<React.SetStateAction<TableState>>

export interface ITableApi {
  setState: SDT;
}

export const initApi = (setState_: SDT): ITableApi => {

  const setState = setState_

  return {
    setState,
  }
}

export const useTableSubcontext = (): ISubContext<TableState, ITableApi> => {

  const [state_, setState_] = useState(new TableState())

  return {
    state: state_,
    api: initApi(setState_),
  }
}
